<mat-menu #smallInputMenu="matMenu" yPosition="above" xPosition="after" class="add-official-menu">
  <div class="input-menu-content" (click)="$event.stopPropagation()">

    <!-- Preset opciók (SZ / TR / B / Egyéni) - csak ha notePresets meg van adva -->
    @if (notePresets !== null) {
      <div class="preset-options">
        @for (preset of notePresets; track preset.value) {
          <button type="button"
                  class="preset-btn"
                  [class.selected]="selectedPreset === preset.value"
                  (click)="selectPreset(preset.value); $event.stopPropagation()">
            {{ preset.label }}
          </button>
        }
        <button type="button"
                class="preset-btn preset-btn-egyeni"
                [class.selected]="selectedPreset === 'Egyéni'"
                (click)="selectPreset('Egyéni'); $event.stopPropagation()">
          Egyéni
        </button>
      </div>
    }

    <!-- Input mező: normál módban mindig, preset módban csak Egyéni opció esetén -->
    @if (notePresets === null || selectedPreset === 'Egyéni') {
      <mat-form-field 
        appearance="outline" 
        class="input-menu-field"
        floatLabel="always">
        <mat-label>{{ currentLabel }}</mat-label>
        <input 
          matInput 
          [formControl]="inputControl"
          [placeholder]="currentPlaceholder"
          [type]="currentInputType"
          [attr.maxlength]="inputType === 'phone' ? 16 : null"
          (input)="onInput()"
          (paste)="onPaste()"
          (keydown)="onKeyDown($event)"
          #inputField>
        @if (inputControl.hasError('invalid') || inputControl.hasError('accented')) {
          <mat-error>
            {{ errorMessage }}
          </mat-error>
        }
        @if (inputType === 'phone') {
          <mat-hint>Érvényes formátum: +36 30 999 9999</mat-hint>
        }
      </mat-form-field>
    }

    <!-- Tervszámok törlése checkbox - csak ha showClearPlanCheckbox igaz -->
    @if (showClearPlanCheckbox) {
      <label class="clear-plan-row" (click)="$event.stopPropagation()">
        <input type="checkbox"
               [(ngModel)]="clearPlanChecked"
               (click)="$event.stopPropagation()">
        <span class="clear-plan-label">Tervszámok törlése</span>
      </label>
    }

    <div class="input-menu-actions" [class.has-delete-button]="showDeleteButton">
      <!-- Delete button on the left side -->
      @if (showDeleteButton) {
        <app-delete-icon-button 
          tooltip="Jegyzet törlése"
          (clicked)="onDeleteClicked()"
          class="delete-action-btn">
        </app-delete-icon-button>
      }

      <!-- Szín választó pontok - csak notes típusnál -->
      @if (inputType === 'notes') {
        <div class="note-color-picker">
          <button
            class="color-dot color-dot-orange"
            [class.selected]="selectedNoteColor === 'orange'"
            (click)="selectNoteColor('orange'); $event.stopPropagation()"
            matTooltip="Narancssárga"
            type="button">
          </button>
          <button
            class="color-dot color-dot-red"
            [class.selected]="selectedNoteColor === 'red'"
            (click)="selectNoteColor('red'); $event.stopPropagation()"
            matTooltip="Piros"
            type="button">
          </button>
        </div>
      }
      
      <div class="action-buttons-right">
        <button mat-icon-button (click)="cancelInput(); $event.stopPropagation()" class="cancel-btn">
          <mat-icon>close</mat-icon>
        </button>
        <button mat-icon-button (click)="saveValue(); $event.stopPropagation()" class="save-btn" 
          [disabled]="!isSaveEnabled">
          <mat-icon>check</mat-icon>
        </button>
      </div>
    </div>
  </div>
</mat-menu>
